/* eslint-disable no-continue */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable camelcase */
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorIcon from "@mui/icons-material/Error";
import React, { useCallback, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";
import SidebarLayout from "@/Components/sidebar/SidebarLayout";

import CommonModal from "./components/common-modal";
import useModal from "./utils/useModal";
import {
  addListingDefaultValues,
  addListingDraftValidationSchema,
  addListingValidationSchema,
} from "./data";
import { useApiGet, useApiMutation } from "./api/general-service";
import { renderImage } from "./utils/render-image";
import ListingFormFields from "./components/ListingFormFields";
import LocationFormFields from "./components/LocationFormFields";
import BedroomFields from "./components/BedroomFields";
import AirportInformationFields from "./components/AirportInformationFields";
import InformationFields from "./components/InformationFields";
import PricingInformationFields from "./components/PricingInformationFields";
import Services from "./components/Services";
import Features from "./components/Features";
import TermsAndRules from "./components/TermsAndRules";
import { NewCustomDateSelectionCalendar } from "@/Components/Add/Listings/components/NewCustomDateSelectionCalendar";
import ImageUploadingComponent from "./components/ImageUploadingComponent";
import Media from "./components/Media";
import { ImagesForm } from "./components/ImagesForm";

const AddListingAdmin = ({ listingId, isDuplicate, draftId }) => {
  const [imagesMarkedForDeletion, setImagesMarkedForDeletion] = useState([]);

  const { open, openModal, closeModal, additionalState } = useModal();
  const [isDraft, setIsDraft] = useState(draftId ? true : false);
  const [imagesOrder, setImagesOrder] = useState([]);
  console.log({ imagesOrder, setImagesOrder });
  // Validation Schema
  const navigate = useNavigate();
  console.log({ draftId, isDraft });
  // Create Form Context using `useForm`
  const methods = useForm({
    mode: "onChange",
    defaultValues: addListingDefaultValues,
    resolver: isDraft
      ? yupResolver(addListingDraftValidationSchema)
      : yupResolver(addListingValidationSchema),
  });

  const {
    handleSubmit,
    reset,
    control,
    getValues,
    formState: { errors },
    setFocus,
    setValue,
    setError,
    watch,
  } = methods; // Destructure required methods from `methods`

  const { mutate: sortImages, isLoading: sortingImages } = useApiMutation({
    endpoint: `/sort-images`,
    method: "post",
    config: {
      onSuccess: () => {
        Swal.fire({
          icon: "success",
          title:
            listingId && !isDuplicate
              ? "Listing updated successfully!"
              : "Listing created successfully",
        });

        fetchListingAgain();
      },
    },
  });

  const {
    mutate: addListing,
    isLoading: savingListing,
    isError,
    error,
  } = useApiMutation({
    endpoint: listingId && !isDuplicate ? `/listing/${listingId}` : `/listing`,
    method: "post",
    config: {
      onSuccess: (success, variables) => {
        console.log({ success, variables });
        try {
          if (draftId) {
            Swal.fire({
              icon: "success",
              title: "Draft updated successfully!",
            });
          }
          if (!draftId) {
            if (listingId) {
              try {
                const savedImages = success?.data?.listing_images;
                console.log({ savedImages });
                const updatedOrderedImages = imagesOrder?.map((item) => {
                  if (item?.file?.includes("https://s3.")) {
                    return {
                      ...item,
                      file: item?.file,
                    };
                  } else {
                    const findImage = savedImages?.find((item) =>
                      item?.images?.includes(imagesOrder?.file?.path)
                    );
                    console.log({ findImage });
                    return {
                      ...item,
                      file: findImage?.image,
                      order: findImage?.order,
                    };
                  }
                });
                console.log({ updatedOrderedImages });

                if (updatedOrderedImages?.length > 0) {
                  return sortImages({
                    images: updatedOrderedImages
                      ?.map((item) => item?.file)
                      ?.filter((file) => file !== null && file !== undefined),
                  });
                }
              } catch (error) {
                console.log("omages error", error);
              }
            }

            Swal.fire({
              icon: "success",
              title:
                listingId && !isDuplicate
                  ? "Listing updated successfully!"
                  : "Listing created successfully",
            });
          } else {
            Swal.fire({
              icon: "success",
              title: "Draft updated successfully!",
            });
          }
          navigate("/add_listing");
          reset(addListingDefaultValues);
        } catch (error) {
          console.log({ error });
        }
      },
      onError: (err) => {
        // Scroll to the first error field
        const firstErrorField = Object.keys(err?.response?.data?.errors)[0];
        if (firstErrorField) {
          setFocus(firstErrorField);
          // Determine if the field name contains special characters
          const isSimpleId = /^[a-zA-Z0-9_-]+$/.test(firstErrorField);
          const normalizedField = isSimpleId
            ? firstErrorField
            : firstErrorField.replace(/\.(\d+)/g, "[$1]");
          const selector = `#${CSS.escape(normalizedField)}`;
          // Smooth scroll to the field
          const errorElement = document.querySelector(selector);
          console.log("error set 1", errorElement);
          if (errorElement) {
            errorElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          } else {
            openModal({
              heading:
                Object.values(err?.response?.data?.message) ||
                "Some error occurred!. kindly try again",
              errorMessage: JSON.stringify(err?.response?.data?.errors),
            });
          }
          console.log(
            "error set 2",
            err?.response?.data,
            Object.entries(err?.response?.data?.errors)
          );
          // Set errors for all fields
          Object.entries(err?.response?.data?.errors).forEach(
            ([key, messages]) => {
              setError(key, { type: "manual", message: messages[0] });
            }
          );
        } else {
          console.log(
            "error set 3",
            Object.entries(err?.response?.data?.message)
          );
          openModal({
            heading:
              Object.values(err?.response?.data?.message) ||
              "Some error occurred!. kindly try again",
            errorMessage: JSON.stringify(err?.response?.data?.errors),
          });
        }
      },
    },
  });
  console.log("formValues", getValues(), "sError,error ", isError, error);
  console.log("errors", errors);
  const appendFormData = useCallback((finalData, data, parentKey = "") => {
    // Skip null, undefined, or empty string
    if (
      data === null ||
      data === undefined ||
      (typeof data === "string" && data.trim() === "")
    ) {
      return;
    }
    if (Array.isArray(data)) {
      // Handle arrays recursively
      data.forEach((item, index) => {
        appendFormData(finalData, item, `${parentKey}[${index}]`);
      });
    } else if (data instanceof Date) {
      // Handle Date objects correctly
      finalData.append(parentKey, data.toISOString());
    } else if (data instanceof File || data instanceof Blob) {
      // Handle File or Blob objects correctly
      finalData.append(parentKey, data);
    } else if (typeof data === "object" && data !== null) {
      // Handle objects recursively
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const value = data[key];
          if (
            value !== null &&
            value !== undefined &&
            !(typeof value === "string" && value.trim() === "")
          ) {
            const newKey = parentKey ? `${parentKey}[${key}]` : key;
            appendFormData(finalData, value, newKey);
          }
        }
      }
    } else {
      // Handle primitives (string, number, boolean)
      finalData.append(parentKey, data);
    }
  }, []);
  // Handle form submission
  const onSubmit = useCallback(
    async (formValues, event) => {
      try {
        event?.preventDefault();
        const { images, ...data } = formValues;
        const finalData = new FormData();
        const newImages = images?.filter((item) => {
          return item?.file instanceof File;
        });
        const updatedData = {
          ...data,
          ...(newImages?.length > 0 && { images: newImages }),
          infant_start_age: data?.infant_ages?.[0],
          infant_end_age: data?.infant_ages?.[1],
          child_start_age: data?.children_ages?.[0],
          child_end_age: data?.children_ages?.[1],
          ...((listingId || draftId) && {
            deleted_images: data?.deleted_images?.join(","),
          }),
          ...(listingId && !isDuplicate && { _method: "PUT" }),
          ...(draftId && { draft_id: draftId }),
          airports: data?.airports?.map((airport) => {
            return {
              ...airport,
              surface: airport?.surface?.join(", "),
              fuel: airport?.fuel?.join(", "),
              ctaf_unicom: airport?.ctaf_unicom
                ? parseFloat(airport?.ctaf_unicom)
                : "",
            };
          }),
          features: data?.features?.map((item) => {
            return {
              id: item?.id,
              sub_features: item?.sub_features,
            };
          }),
          city_fee: data?.city_fee ? parseFloat(data?.city_fee) : "",
          cleaning_fee: data?.cleaning_fee
            ? parseFloat(data?.cleaning_fee)
            : "",
          nightly_price: parseFloat(data?.nightly_price || 0),
          nightly_price_seven_plus: parseFloat(
            data?.nightly_price_seven_plus || 0
          ),
          nightly_price_thirty_plus: parseFloat(
            data?.nightly_price_thirty_plus || 0
          ),
          tax_percentage: parseFloat(data?.tax_percentage || 0),
        };
        appendFormData(finalData, updatedData);
        const imageOrder = images?.map((item, index) => {
          return {
            file:
              typeof item?.file === "string" ? item?.file : item?.file?.path,
            order: index,
          };
        });
        setImagesOrder(imageOrder?.length > 0 ? imageOrder : []);
        addListing(finalData);
      } catch (err) {
        console.log(err);
      }
    },
    [appendFormData, getValues, errors, isDraft]
  );

  const { data: featureList, isLoading: loadingFeatures } = useApiGet({
    endpoint: `/feature`,
    queryKey: ["feature"],
    config: {
      select: (data) => {
        return data?.data?.data;
      },
      onSuccess: () => {
        (listingId || draftId) && fetchListingAgain();
      },
    },
  });
  function parseToArray(input) {
    let result = [];
    if (Array.isArray(input)) {
      return input;
      // if its already an array
    }
    // Check if the input is a stringified JSON
    try {
      const parsed = JSON.parse(input);
      // If it parses successfully, handle it
      if (typeof parsed === "string") {
        result = parsed.split(",").map((item) => item.trim());
      } else if (typeof parsed === "object" && Array.isArray(parsed)) {
        result = parsed;
      } else {
        throw new Error("Not a stringified string");
      }
    } catch (error) {
      console.log({ error, input });
      // If JSON.parse fails, handle it as a plain string
      if (typeof input === "string") {
        result = input.split(",").map((item) => item.trim());
      }
    }
    console.log({ result, input });
    return result;
  }
  const { refetch: fetchListingAgain, isLoading: loadingListing } = useApiGet({
    endpoint: draftId ? `/draft/${draftId}` : `/listing/${listingId}`,
    queryKey: draftId ? ["draft", draftId] : ["listing", listingId],
    config: {
      select: (data) => {
        return draftId ? data?.data?.draft : data?.data?.listing;
      },
      enabled: !!listingId || !!draftId,
      onSuccess: (res) => {
        const {
          host,
          host_id,
          address,
          unit_no,
          city,
          state,
          zipcode,
          area,
          country,
          longitude,
          latitude,
          images,
          type_of_space,
          lodging_type,
          title,
          no_of_guest,
          no_of_bedrooms,
          no_of_beds,
          no_of_bathrooms,
          no_of_rooms,
          unit_of_measure,
          size,
          description,
          bedrooms,
          airports,
          instant_booking,
          nightly_price,
          nightly_price_seven_plus,
          nightly_price_thirty_plus,
          apply_weekend_price,
          weekend_nightly_price,
          additional_guest,
          no_of_additional_guest,
          additional_guest_price,
          pet_allowed,
          no_of_pets,
          price_per_pet,
          cleaning_fee,
          cleaning_freq,
          city_fee,
          city_fee_freq,
          tax_percentage,
          custom_periods,
          extra_services,
          extra_service,
          features,
          cancellation_policy_short,
          cancellation_policy_long,
          min_day_booking,
          max_day_booking,
          check_in_after,
          check_out_before,
          smoking_allowed,
          smoking_rules,
          rules_pet_allowed,
          pet_rules,
          party_allowed,
          party_rules,
          children_allowed,
          children_rules,
          child_start_age,
          child_end_age,
          infant_start_age,
          infant_end_age,
          rules,
          welcome_message,
          helicopter_allowed,
        } = res || {};
        const updatedFeatures =
          featureList?.length > 0
            ? features &&
              features?.length > 0 &&
              features?.map((item) => {
                return {
                  id: item?.id,
                  sub_features: item?.sub_features?.map((el) => +el),
                  sub_feature_options: featureList?.filter((el) => {
                    return +el?.id === +item?.id;
                  })?.[0]?.feature_detail,
                };
              })
            : [
                {
                  id: "",
                  sub_features: [],
                },
              ];
        console.log({ host, features, featureList, updatedFeatures });
        const resetData = {
          blocked_dates: res?.blocked_dates || [],
          listing_type: res?.listing_type?.toLowerCase(),
          host_id: listingId ? host?.id : host_id,
          address,
          unit_no: unit_no,
          city,
          state,
          zipcode,
          area,
          country,
          longitude,
          latitude,
          images: isDuplicate
            ? []
            : images?.map((item) => {
                return {
                  description: item?.description,
                  id: item?.id,
                  file: item.file_name
                    ? item.file_name
                    : renderImage(item?.image),
                };
              }),
          type_of_space,
          lodging_type,
          title,
          no_of_guest,
          no_of_bedrooms: no_of_bedrooms || 0,
          no_of_beds: no_of_beds || 0,
          no_of_bathrooms: parseFloat(no_of_bathrooms || 0),
          no_of_rooms: no_of_rooms || 0,
          unit_of_measure,
          size,
          description,
          bedrooms,
          helicopter_allowed: helicopter_allowed || 0,
          airports:
            airports && Array.isArray(airports) && airports?.length > 0
              ? airports?.map((airport) => {
                  return {
                    ...airport,
                    fuel: parseToArray(airport.fuel),
                    surface: parseToArray(airport.surface),
                    dimension_feetX: airport?.dimension_feets
                      ?.split("X")?.[0]
                      ?.trim(),
                    dimension_feetY: airport?.dimension_feets
                      ?.split("X")?.[1]
                      ?.trim(),
                    dimension_metersX: airport?.dimension_meters
                      ?.split("X")?.[0]
                      ?.trim(),
                    dimension_metersY: airport?.dimension_meters
                      ?.split("X")?.[1]
                      ?.trim(),
                    ctaf_unicom: parseFloat(airport?.ctaf_unicom || 0),
                    distance_from_runway: parseFloat(
                      airport?.distance_from_runway || 0
                    ),
                    elevation_feets: parseFloat(airport?.elevation_feets || 0),
                    elevation_meters: parseFloat(
                      airport?.elevation_meters || 0
                    ),
                    ground_transportation: airport?.ground_transportation ?? "",
                  };
                })
              : [
                  {
                    airport_identifier: "",
                    airport_name: "",
                    airport_use: "",
                    operation_hours: "",
                    lighting: 0,
                    ctaf_unicom: "",
                    fuel: [],
                    surface: [],
                    parking: "",
                    orientation: "",
                    runway_condition: "",
                    pattern: "",
                    elevation_feets: "",
                    elevation_meters: "",
                    distance_from_runway: "",
                    air_nav: "",
                    ground_transportation: "",

                    additional_info: "",
                    dimension_feetX: "",
                    dimension_feetY: "",
                    dimension_metersX: "",
                    dimension_metersY: "",
                  },
                ],
          instant_booking,
          nightly_price: nightly_price ? parseFloat(nightly_price || 0) : "",
          nightly_price_seven_plus: nightly_price_seven_plus
            ? parseFloat(nightly_price_seven_plus)
            : "",
          nightly_price_thirty_plus: nightly_price_thirty_plus
            ? parseFloat(nightly_price_thirty_plus || 0)
            : "",
          apply_weekend_price: apply_weekend_price || "",
          weekend_nightly_price: weekend_nightly_price
            ? parseFloat(weekend_nightly_price) === 0
              ? ""
              : parseFloat(weekend_nightly_price)
            : "",
          additional_guest: additional_guest || 0,
          no_of_additional_guest: no_of_additional_guest || 0,
          additional_guest_price: additional_guest_price
            ? parseFloat(additional_guest_price || 0)
            : "",
          pet_allowed: pet_allowed || 0,
          no_of_pets: no_of_pets || "",
          price_per_pet: price_per_pet ? parseFloat(price_per_pet || 0) : "",
          cleaning_fee: cleaning_fee ? parseFloat(cleaning_fee || 0) : "",
          cleaning_freq,
          city_fee: city_fee ? parseFloat(city_fee || 0) : "",
          city_fee_freq,
          tax_percentage: tax_percentage ? parseFloat(tax_percentage || 0) : "",
          custom_periods: custom_periods?.map((item) => {
            return {
              ...item,
              nightly_price: item?.nightly_price
                ? parseFloat(item?.nightly_price || 0)
                : "",
              price_add_guest: item?.price_add_guest
                ? parseFloat(item?.price_add_guest || 0)
                : "",
            };
          }),
          custom_period_pricing: custom_periods?.length > 0 ? 1 : 0,
          extra_service: (listingId ? extra_services : extra_service)?.map(
            (item) => {
              return {
                ...item,
                price: item?.price ? parseFloat(item?.price || 0) : "",
                quantity: item?.quantity ? parseFloat(item?.quantity || 1) : "",
              };
            }
          ),
          extra_services:
            (listingId ? extra_services : extra_service)?.length > 0 ? 1 : 0,
          features: listingId
            ? featureList &&
              Array.isArray(featureList) &&
              featureList?.length > 0
              ? features?.map((item) => {
                  return {
                    id: item?.feature_id,
                    sub_features: item?.sub_features?.map((el) => el?.id),
                    sub_feature_options: featureList?.filter((el) => {
                      return el?.id === item?.feature_id;
                    })?.[0]?.feature_detail,
                  };
                })
              : [
                  {
                    id: "",
                    sub_features: [],
                  },
                ]
            : updatedFeatures,
          cancellation_policy_short: listingId
            ? cancellation_policy_short?.id
            : cancellation_policy_short,
          cancellation_policy_long: listingId
            ? cancellation_policy_long?.id
            : cancellation_policy_long,
          min_day_booking,
          max_day_booking,
          check_in_after: check_in_after?.trim(),
          check_out_before: check_out_before?.trim(),
          children_ages: [child_start_age, child_end_age],
          infant_ages: [infant_start_age, infant_end_age],
          smoking_allowed,
          smoking_rules: smoking_rules || "",
          rules_pet_allowed,
          pet_rules: pet_rules || "",
          party_allowed,
          party_rules: party_rules || "",
          children_allowed,
          children_rules: children_rules || "",
          rules: rules || "Host needs to add house rules here",
          welcome_message:
            welcome_message || "Host needs to add house rules here",
        };
        const resetData1 = null;
        console.log({ resetData, resetData1 });
        reset(resetData);
      },
    },
  });
  const onError = (errors) => {
    console.log("scroll errors", { errors });
    // Scroll to the first error field
    const firstErrorField = Object.keys(errors)[0];
    console.log({ firstErrorField, errors });
    if (firstErrorField) {
      setFocus(firstErrorField);
      // Smooth scroll to the field
      const errorElement = document.querySelector(`[id="${firstErrorField}"]`);
      console.log({ errorElement });
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        openModal({
          heading:
            "Oops there is some issue, kindly verify all form fields and then submit again or try  reloading the page and try again!",
        });
      }
    }
  };

  const imagesUploaded = watch("images");
  console.log("get values", getValues());
  console.log("imagesUploaded", imagesUploaded);
  const is_draft_value = watch("is_draft");
  const listingTitle = watch("title");
  function copyJsonToClipboard() {
    const jsonData = getValues();
    try {
      const jsonString = JSON.stringify(jsonData, null, 2);
      navigator.clipboard.writeText(jsonString);
      console.log("JSON data copied to clipboard!");
      // Optional: Provide visual feedback to the user
      alert("JSON data copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy JSON data: ", err);
      fallbackCopyJsonToClipboard(jsonData);
    }
  }
  function fallbackCopyJsonToClipboard(jsonData) {
    const jsonString = JSON.stringify(jsonData, null, 2);
    const textArea = document.createElement("textarea");
    textArea.value = jsonString;
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand("copy");
      const msg = successful ? "successful" : "unsuccessful";
      console.log("Fallback: Copying text command was " + msg);
      alert("JSON data copied to clipboard! (fallback)");
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
      alert("Copy failed!");
    }
    document.body.removeChild(textArea);
  }
  if (loadingFeatures || loadingListing) {
    return "loading...";
  }
  return (
    <SidebarLayout>
      <div className="container px-4 md:px-8 ">
        <p className="mb-2 text-4xl font-bold">
          {listingId
            ? isDuplicate
              ? "Duplicate Listing"
              : "Edit Listing"
            : draftId
            ? "Update Draft"
            : "Add Listing"}
        </p>
        <div className="overflow-visible rounded-lg bg-white p-6 shadow-md">
          {/* Provide Form Context */}
          <FormProvider {...methods}>
            <form
              onSubmit={handleSubmit(onSubmit, onError)}
              className="flex flex-col gap-5"
            >
              <ListingFormFields />
              <LocationFormFields />
              <ImagesForm />

              <InformationFields />
              <BedroomFields />
              <AirportInformationFields />
              <PricingInformationFields />
              <Services />
              <Features />
              <TermsAndRules />
              <NewCustomDateSelectionCalendar />
              {!draftId && (
                <div className="sticky bottom-0 z-10 flex w-full justify-end gap-4 rounded-sm bg-[#fcefef] px-6 py-3 shadow-xl">
                  <div className="flex gap-4">
                    <div className="flex flex-col items-end">
                      <button
                        type="button"
                        className={`rounded-md border border-gray-300 bg-white px-4 py-2 font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${
                          is_draft_value && savingListing
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        disabled={is_draft_value && savingListing}
                        onClick={async () => {
                          setIsDraft(true);
                          setValue("is_draft", 1);
                          setTimeout(async () => {
                            handleSubmit(onSubmit, onError)();
                          }, 0);
                        }}
                      >
                        Save as draft
                      </button>
                    </div>
                    <div className="flex flex-col items-end">
                      <button
                        type="submit"
                        className={`rounded-md border border-transparent bg-indigo-600 px-4 py-2 font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${
                          !is_draft_value && (savingListing || sortingImages)
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        disabled={
                          !is_draft_value && (savingListing || sortingImages)
                        }
                        onClick={async () => {
                          setIsDraft(false);
                          setValue("is_draft", 0);
                          // setTimeout(async () => {
                          //   handleSubmit(onSubmit, onError)();
                          // }, 0);
                        }}
                      >
                        {listingId && !isDuplicate
                          ? "Updating Listing"
                          : "Add Listing"}
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {draftId && (
                <div className="sticky bottom-0 z-10 flex w-full justify-end gap-4 rounded-sm bg-[#fcefef] px-6 py-3 shadow-xl">
                  <div className="flex justify-end gap-4">
                    <button
                      type="submit"
                      className={`rounded-md border border-transparent bg-indigo-600 px-4 py-2 font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${
                        savingListing ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                      disabled={savingListing}
                      onClick={async () => {
                        setValue("is_draft", 1);
                        handleSubmit(onSubmit, onError)();
                      }}
                    >
                      Update Draft
                    </button>
                    <button
                      type="submit"
                      className={`rounded-md border border-transparent bg-red-600 px-4 py-2 font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none ${
                        !is_draft_value && savingListing
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
                      disabled={!is_draft_value && savingListing}
                      onClick={async () => {
                        setIsDraft(false);
                        setValue("is_draft", 0);
                        setTimeout(async () => {
                          handleSubmit(onSubmit, onError)();
                        }, 0);
                      }}
                    >
                      {listingId && !isDuplicate
                        ? "Updating Listing"
                        : "Add as Listing"}
                    </button>
                  </div>
                </div>
              )}
              {/* <button
                type="button"
                className="mt-4 rounded-md border border-gray-300 bg-white px-4 py-2 font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none "
                onClick={() => {
                  copyJsonToClipboard();
                }}
              >
                Copy Data
              </button> */}
            </form>
          </FormProvider>
        </div>
        <CommonModal
          open={open}
          onClose={closeModal}
          title="Error"
          style={{ minWidth: "400px" }}
          secondaryAction={{
            label: "Cancel",
            onClick: closeModal,
          }}
        >
          <div className="flex flex-col items-center">
            <ErrorIcon />
            <p className="m-0 text-xl">{additionalState?.heading}</p>
            {additionalState?.errorMessage && (
              <p className="mb-2 m-0 text-sm font-semibold text-black">
                Oops!, it looks like there is some issue , kindly share the
                message below with the developer.
              </p>
            )}
            <p className="m-0 text-start text-sm">
              {additionalState?.errorMessage}
            </p>
          </div>
        </CommonModal>
      </div>
    </SidebarLayout>
  );
};
export default AddListingAdmin;
